<template>
  <div class="CoveragesForm">
    <h2 class="gl_form-title">{{ t('rater.health.coverages.form-legend') }}</h2>
    <p>
      {{ t('rater.health.coverages.description') }}
    </p>
    <CoverageRadioGroup
      id="coverages"
      :coverages="coverages"
      :value="coverage"
      v-model="coverage"
      :validation-rules="validationRules.required"
    />
  </div>
</template>
<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { useHealthStore } from '@/modules/health/rater/stores/index'
import { useErrorManagerComposable } from '@/modules/core/composables/errorManagerComposable'
import CoverageRadioGroup from '@/modules/common/common/components/coverages/CoverageRadioGroup.vue'
import type CoverageBasic from '@/modules/common/common/models/APP/CoverageBasic'

defineExpose({ triggerSubmit })

interface PropsInterface {
  nextForm: String[]
  answers: Record<string, any>
  configurations: Record<string, any>
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const loadingStore = useLoadingStore()
const healthStore = useHealthStore()
const errorManager = useErrorManagerComposable()
const { t } = useI18n()
const { required } = useRules()

const validationRules = {
  required: (value: string) => required(value, 'common.validations.option')
}

const coverages = ref<CoverageBasic[]>([])
const coverage = ref(props.answers.coverage)

function triggerSubmit() {
  const page = props.nextForm[0]
  const answers = {
    coverage: coverage.value
  }

  return { page, answers }
}

onBeforeMount(async () => {
  try {
    loadingStore.startLoading()
    coverages.value = await healthStore.loadCoverages({})
  } catch (error) {
    errorManager.handleError(error)
  } finally {
    loadingStore.stopLoading()
  }
})
</script>
<style lang="scss" scoped>
  .CoveragesForm {
    p {
      color: $color-neutral;
    }
  }
</style>
